import {NodeData} from '../system/nodes/interfaces';

/*
    Найти узел в дереве по идентификатору
*/
export function findNodeById(id: number | undefined, items: NodeData[]) {
  const stack = [...items];
  while (stack.length) {
    const x = stack.pop();
    if (x && x.id == id) return x;
    if (x && x.children) x.children.forEach(c => stack.push(c));
  }
  return null;
}
